import { render, staticRenderFns } from "./AffiliateShareForm.vue?vue&type=template&id=78708158&scoped=true"
import script from "./AffiliateShareForm.vue?vue&type=script&lang=js"
export * from "./AffiliateShareForm.vue?vue&type=script&lang=js"
import style0 from "./AffiliateShareForm.vue?vue&type=style&index=0&id=78708158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78708158",
  null
  
)

export default component.exports